import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { beaconSelector, mortgageSelector } from '../recoil/selector';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';
import { useEffect } from 'react';

export const useMtgNum = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_NUM,
  });
  const sendBeaconClkBtnOption = ({
    btmsheet_name,
    option_name,
    before_option_name,
  }: IClkBtnOptionProperties) => {
    beacon.sendClkBtnOption({
      properties: <IClkBtnOptionProperties>{
        btmsheet_name: btmsheet_name,
        option_name: option_name,
        before_option_name: before_option_name,
      },
    });
  };
  useEffect(() => {
    beacon.sendViewPage();
  }, []);
  return { sendBeaconClkBtnOption };
};
